import React from 'react';
import { useHistory } from 'react-router-dom';

import '../../teacher_payments/teacher_payments.css';
import { can_see_payment_details, payment_details_url } from './logic';

// entry point on the teacher profile; the cards themselves self-gate on the page.
const PaymentDetailsButton = ({ teacher_uuid, access_type }) => {
  const history = useHistory();
  if (!teacher_uuid || !can_see_payment_details(access_type)) return null;
  return (
    <button
      type="button"
      className="tp-btn-out"
      onClick={() => history.push(payment_details_url(teacher_uuid))}
    >
      Payment details
    </button>
  );
};

export default PaymentDetailsButton;
